/**
 * @nubeteck/icons (0.7.0)
 * Copyright (c) Nubeteck, SRL.
 */
import n from "styled-components";
const r = n.i`
  font-family: "Tabler Icons";
  line-height: 1;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  color: ${(o) => o.color};
  font-size: ${(o) => `${o.$size}px`};
  cursor: ${(o) => o.$cursor ?? "default"};

  ${({ theme: o, $hover: t }) => t && `&:hover {
      color: ${o.colors?.primary500};
    }`}

  &::before {
    content: ${(o) => `'\\${o.$unicode}'`};
  }

  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
export {
  r as TablerIconStyled
};
